import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精选专题</h2>
          <p className="text-foreground-600">按主题分类整理，快速找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="relative overflow-hidden" style={{ aspectRatio: '8/5' }}>
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`七七影院 ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className="inline-block px-2 py-1 rounded-md bg-background-50/90 text-xs font-semibold text-foreground-950">
                    {item.count}{item.label}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}